import { RuleResult } from 'types/DeclarationP5'

const C0822Validator = {
  validateContainerIndicatorRequirement: ({
    additionalDeclarationType,
  }: {
    additionalDeclarationType: string
  }): RuleResult => {
    if (additionalDeclarationType === 'D') return 'OPTIONAL'
    return 'REQUIRED'
  }

  ,
} as const

export default C0822Validator
